import { Component, inject } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
  MatDialogClose,
} from '@angular/material/dialog';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { SicotService } from '../../sicot.service';
import { QualificaReferentiOperatori } from '../../types/QualificaReferentiOperatori';
import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';

export interface QualificaRefOpDialogData {
  qualifica?: QualificaReferentiOperatori | null;
}

@Component({
  selector: 'app-qualifica-ref-op-dialog',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
  ],
  templateUrl: './qualifica-ref-op-dialog.component.html',
  styleUrl: './qualifica-ref-op-dialog.component.css',
})
export class QualificaRefOpDialogComponent {
  private readonly fb = inject(FormBuilder);
  private readonly sicot = inject(SicotService);
  private readonly dialogRef = inject(MatDialogRef<QualificaRefOpDialogComponent>);
  readonly data = inject<QualificaRefOpDialogData>(MAT_DIALOG_DATA);

  form = this.fb.group({
    id: [{ value: this.data?.qualifica?.id ?? null, disabled: !!this.data?.qualifica }, [Validators.required]],
    codice: [this.data?.qualifica?.codice ?? '', [Validators.required]],
    descrizione: [this.data?.qualifica?.descrizione ?? '', [Validators.required]],
  });

  isEdit = !!this.data?.qualifica;
  submitting = false;
  errorMessage: string | null = null;

  submit(): void {
    if (this.form.invalid || this.submitting) return;
    this.errorMessage = null;
    this.submitting = true;
    const raw = this.form.getRawValue();
    const id = raw.id as number;
    const codice = raw.codice as string;
    const descrizione = raw.descrizione as string;

    if (this.isEdit) {
      this.sicot.updateQualificaRefOp(id, { codice, descrizione }).subscribe({
        next: (updated: QualificaReferentiOperatori) => this.dialogRef.close(updated),
        error: (err: HttpErrorResponse) => {
          this.errorMessage = err?.error?.message ?? 'Errore durante l\'aggiornamento.';
          this.submitting = false;
        },
      });
    } else {
      this.sicot.createQualificaRefOp({ id, codice, descrizione }).subscribe({
        next: (created: QualificaReferentiOperatori) => this.dialogRef.close(created),
        error: (err: HttpErrorResponse) => {
          this.errorMessage = err?.status === 409
            ? 'Una qualifica con questo id esiste già.'
            : (err?.error?.message ?? 'Errore durante la creazione.');
          this.submitting = false;
        },
      });
    }
  }
}
